const config = {
  snackbar_error: {
    style: {
      backgroundColor: '#a01200',
    },
  },
  snackbar_success: {
    style: {
      backgroundColor: '#299c00',
    },
  },
};

export default config;
